module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "updateCsvTable",
      "title": _vm.importTitle,
      "visible": _vm.dialogVisible,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "csvFile",
    attrs: {
      "type": "file",
      "name": "File Upload",
      "accept": ".csv"
    },
    on: {
      "change": function($event) {
        return _vm.handleFilesUpload()
      }
    }
  }), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.csvFile.length === 0),
      expression: "csvFile.length === 0"
    }],
    staticClass: "choose-btn",
    on: {
      "click": _vm.chooseCSV
    }
  }, [_vm._v("選擇檔案")]), _vm._v(" "), (!_vm.importStart && _vm.csvFile && _vm.csvFile.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.csvFile,
      "empty-text": "暫無資料"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "90",
      "prop": "name",
      "label": "原工號"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "displayname",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "新工號",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('editable-cell', {
          attrs: {
            "can-edit": true
          },
          model: {
            value: (row.new_id),
            callback: function($$v) {
              _vm.$set(row, "new_id", $$v)
            },
            expression: "row.new_id"
          }
        }, [_c('span', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(row.new_id))])])
      }
    }], null, false, 1683281321)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Email",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('editable-cell', {
          attrs: {
            "can-edit": true
          },
          model: {
            value: (row.email),
            callback: function($$v) {
              _vm.$set(row, "email", $$v)
            },
            expression: "row.email"
          }
        }, [_c('span', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(row.email))])])
      }
    }], null, false, 4029417673)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Level",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('editable-cell', {
          attrs: {
            "can-edit": true,
            "editable-component": "el-select",
            "align": "center",
            "close-event": "change"
          },
          model: {
            value: (row.level),
            callback: function($$v) {
              _vm.$set(row, "level", $$v)
            },
            expression: "row.level"
          }
        }, [_c('el-tag', {
          attrs: {
            "slot": "content",
            "size": "medium"
          },
          slot: "content"
        }, [_vm._v("\n                    " + _vm._s(_vm.formatLevel(row)) + "\n                ")]), _vm._v(" "), _c('template', {
          slot: "edit-component-slot"
        }, [_c('el-option', {
          attrs: {
            "value": "1",
            "label": "Level 1"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": "2",
            "label": "Level 2"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": "3",
            "label": "Level 3"
          }
        })], 1)], 2)
      }
    }], null, false, 3653366108)
  }), _vm._v(" "), (_vm.$store.state.isSystemAdminMode) ? _c('el-table-column', {
    attrs: {
      "label": "Department",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('el-cascader', {
          attrs: {
            "placeholder": "請選擇",
            "show-all-levels": false,
            "options": _vm.actualDepsOptions
          },
          model: {
            value: (row.selectedDepId),
            callback: function($$v) {
              _vm.$set(row, "selectedDepId", $$v)
            },
            expression: "row.selectedDepId"
          }
        })
      }
    }], null, false, 54656613)
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.importStart && _vm.csvFile && _vm.csvFile.length > 0 && !_vm.csvTrasfer),
      expression: "!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
    }],
    staticClass: "csv-hint"
  }, [_vm._v("載入csv後中文字出現亂碼嗎 ? 請點擊「UTF8編碼轉換」按鈕後再繼續執行編輯動作或參閱\n        ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.importStart && _vm.csvFile && _vm.csvFile.length > 0 && !_vm.csvTrasfer),
      expression: "!importStart && csvFile && csvFile.length > 0 && !csvTrasfer"
    }],
    staticClass: "download-csv-hint",
    attrs: {
      "href": "./static/CSV_UTF8_Format.pdf",
      "download": "CSV_UTF8_Format.pdf"
    }
  }, [_vm._v("csv格式轉檔說明\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.importStart && _vm.csvFile && _vm.csvFile.length > 0),
      expression: "!importStart && csvFile && csvFile.length > 0"
    }],
    staticClass: "btn-area"
  }, [_c('el-button', {
    staticClass: "import-btn",
    on: {
      "click": _vm.importCSV
    }
  }, [_vm._v("\n                確定匯入\n            ")]), _vm._v(" "), _c('el-button', {
    staticClass: "renew-btn",
    on: {
      "click": _vm.chooseCSV
    }
  }, [_vm._v("\n                重新選擇\n            ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.csvTrasfer),
      expression: "!csvTrasfer"
    }],
    staticClass: "utf8-btn",
    on: {
      "click": _vm.utf8CSV
    }
  }, [_vm._v("\n                UTF8編碼轉換\n            ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.csvTrasfer),
      expression: "csvTrasfer"
    }],
    staticClass: "utf8-btn",
    on: {
      "click": _vm.big5CSV
    }
  }, [_vm._v("\n                BIG5編碼轉換\n            ")])], 1), _vm._v(" "), _c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.importStart),
      expression: "importStart"
    }],
    attrs: {
      "percentage": _vm.importPercent
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c6bb576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/AccountUpdate.vue
// module id = 905
// module chunks = 170